export const shopMessages = {
  allCategories: ['Все категории', 'All categories', 'Bütün kateqoriyalar'],
  region: ['Регион', 'Region', 'Region'],
  district: ['Район', 'District', 'Rayon'],
  quantity: ['Количество', 'Quantity', 'Say'],
  purchases: ['Покупки', 'Purchases', 'Alışlar'],
  sales: ['Продажи', 'Sales', 'Satışlar'],
  deals: ['Сделки', 'Deals', 'Sövdələşmələr'],
  cash: ['Наличные', 'Cash', 'Nağd'],
  paid: ['Оплачено', 'Paid', 'Ödənilib'],
  payInCash: [
    'Оплата наличными при встрече',
    'Pay cash on collection',
    'Görüşdə nağd ödəniş',
  ],
  fundsNotHeld: [
    'Средства не заморожены. Повторная оплата заблокирована; проверьте сделку.',
    'Funds were not held. Paying again is blocked; check the deal.',
    'Vəsait saxlanılmayıb. Təkrar ödəniş bloklanıb; sövdələşməni yoxlayın.',
  ],
  fundsNotDebited: [
    'Средства не списаны',
    'Funds have not been debited',
    'Vəsait tutulmayıb',
  ],
  seller: ['Продавец', 'Seller', 'Satıcı'],
  buyer: ['Покупатель', 'Buyer', 'Alıcı'],
  buy: ['Оформить сделку', 'Place order', 'Sifariş ver'],
  sold: ['Продано', 'Sold', 'Satılıb'],
  moderation: [
    'На проверке · обычно до 24 часов',
    'Under review · usually up to 24 hours',
    'Yoxlanılır · adətən 24 saata qədər',
  ],
  draftRetention: [
    'Черновик хранится на сервере 31 день после изменения.',
    'Drafts are kept for 31 days after the last change.',
    'Qaralamalar son dəyişiklikdən sonra 31 gün saxlanılır.',
  ],
  discard: ['Не сохранять', 'Discard changes', 'Saxlama'],
  fivePhotos: ['Выберите от 1 до 5 фотографий', 'Choose 1–5 photos', '1–5 foto seçin'],
  handedOver: ['Передан', 'Handed over', 'Təhvil verilib'],
  received: ['Получен', 'Received', 'Alınıb'],
  completed: ['Завершена', 'Completed', 'Tamamlanıb'],
  createdAt: ['Создано', 'Created', 'Yaradılıb'],
  cancelled: ['Отменена', 'Cancelled', 'Ləğv edilib'],
  dispute: ['Спор', 'Dispute', 'Mübahisə'],
  expiring: [
    'Сделка истекает: 7 дней без действий',
    'Deal expiring: 7 days without action',
    'Sövdələşmənin vaxtı bitir: 7 gün fəaliyyətsiz',
  ],
  cancelDeal: ['Отменить сделку', 'Cancel deal', 'Sövdələşməni ləğv et'],
  disputeDeal: ['Открыть спор', 'Open dispute', 'Mübahisə aç'],
  reason: [
    'Причина · до 500 символов',
    'Reason · up to 500 characters',
    'Səbəb · 500 simvola qədər',
  ],
  moderatorResolved: [
    'Решено модератором',
    'Resolved by moderator',
    'Moderator tərəfindən həll edilib',
  ],
  reviewSent: ['Жалоба отправлена', 'Report sent', 'Şikayət göndərildi'],
  saved: ['Сохранено', 'Saved', 'Saxlanılıb'],
  minutes: ['мин', 'min', 'dəq'],
} as const;
